import HotelsAPI from "@/api/hotels"

import SoundService from "@/services/sound";

import Vue from 'vue'

const state = {
    room_orders: []
};

const mutations = {
    setRoomOrders(state, payload) {
        state.room_orders = payload;
    },
    setClosed(state, id) {
        const index = state.room_orders.findIndex(ro => ro._id == id);

        Vue.set(state.room_orders[index], 'status', 'closed');
    }
};

const actions = {
    fetchList(context) {
        HotelsAPI.getRoomOrders().then(data => {
            if (context.state.room_orders.length < data.list.length) {
                SoundService.playNewOrder();
            }

            context.commit('setRoomOrders', data.list);
        }).catch(error => {

        });
    },
    acceptRoomOrder(context, payload) {
        HotelsAPI.acceptRoomOrder(payload.id, payload.waiting_time).then(data => {
            context.dispatch('fetchList');
        }).catch(error => {

        });
    },
    cancelRoomOrder(context, payload) {
        HotelsAPI.cancelRoomOrder(payload.id, payload.reason).then(data => {
            context.dispatch('fetchList');
        }).catch(error => {

        });
    },
    closeRoomOrder(context, payload) {
        HotelsAPI.closeRoomOrder(payload.id, payload.pay_method, payload.discount).then(data => {
            // context.dispatch('fetchList');
            context.commit('setClosed', payload.id);
        }).catch(error => {

        });
    },
    payRoomOrder(context, payload) {
        HotelsAPI.payRoomOrder(payload.id).then(data => {
            context.dispatch('fetchList');
        }).catch(error => {

        });
    }
};

const getters = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}